import React, { Component } from "react";
import '@fortawesome/fontawesome-free/css/all.min.css';
// import "bootstrap-css-only/css/bootstrap.min.css";
// import "mdbreact/dist/css/mdb.css";
import { MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavItem, MDBNavLink, MDBNavbarToggler, MDBCollapse, MDBDropdown,
MDBDropdownToggle, MDBDropdownMenu, MDBDropdownItem } from "mdbreact";
import { BrowserRouter as Router } from 'react-router-dom';

import { GoogleLogin, GoogleLogout } from 'react-google-login';
import {Login} from "../data/data";
import Live_layout  from "../live_bar/live_index";
import "./user_bar.css";

// const CLIENT_ID = '374169744841-t3ekshrangb1aerf3th3kuv8fsu5efbq.apps.googleusercontent.com';

 
class NavBar extends Component {
state = {
  isOpen: false,
  loggedIn : false,
  user_id : "guest",
  user_name : "Guest User",
  img_url : "",
  auth_token : "",
};
componentDidMount () {
  console.log(" User_INDEX >> Did_Mount");
    const script = document.createElement("script");
    script.src = "https://apis.google.com/js/platform.js";
    script.async = true;
    document.body.appendChild(script);
}
toggleCollapse = () => {
  this.setState({ isOpen: !this.state.isOpen });
}
onSignIn = (googleUser) => {
    var profile = googleUser.getBasicProfile();
		// console.log('ID: ' + profile.getId());
		// console.log('Full Name: ' + profile.getName());
		// console.log('Given Name: ' + profile.getGivenName());
		// console.log('Family Name: ' + profile.getFamilyName());
		// console.log('Image URL: ' + profile.getImageUrl());
    // console.log('Email: ' + profile.getEmail());
    
		this.setState({loggedIn:true});
		this.setState({user_id:profile.getId()});
		this.setState({user_name:profile.getName()});
		this.setState({img_url:profile.getImageUrl()});
    Login([profile.getId(), profile.getName(), profile.getEmail(), profile.getImageUrl()])
       .then(data => {
          //  console.log("hello", data.data);
           this.setState({auth_token : data.data["auth-token"]});
           this.props.data.auth_info(data.data["auth-token"], profile.getEmail());
           this.props.data.loggedIn(true);
           }
        );
  };
signOut = () => {
        console.log('User signed out.');
		this.setState({loggedIn:false});
    this.props.data.jwt_auth_token("signed_out");
    this.props.data.signout();
    this.props.data.loggedIn(false);
    };

render() {
  console.log(" User_INDEX >> Render");
  return (
    <Router>
      <MDBNavbar color="default-color" dark expand="md">
        <MDBNavbarBrand>
          <strong className="white-text">Docs-io</strong>
        </MDBNavbarBrand>
        <MDBNavbarToggler onClick={this.toggleCollapse} />
        <Live_layout/>
        <MDBCollapse id="navbarCollapse3" isOpen={this.state.isOpen} navbar>
          {/* <MDBNavbarNav left>
            <MDBNavItem active>
              <MDBNavLink to="#!">Home</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem>
              <MDBNavLink to="#!">Features</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem>
              <MDBNavLink to="#!">Pricing</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem>
              <MDBDropdown>
                <MDBDropdownToggle nav caret>
                  <div className="d-none d-md-inline">Dropdown</div>
                </MDBDropdownToggle>
                <MDBDropdownMenu className="dropdown-default">
                  <MDBDropdownItem href="#!">Action</MDBDropdownItem>
                  <MDBDropdownItem href="#!">Another Action</MDBDropdownItem>
                  <MDBDropdownItem href="#!">Something else here</MDBDropdownItem>
                  <MDBDropdownItem href="#!">Something else here</MDBDropdownItem>
                </MDBDropdownMenu>
              </MDBDropdown>
            </MDBNavItem>
          </MDBNavbarNav> */}
          <MDBNavbarNav right>
			  {this.state.loggedIn? 
			   <><MDBNavItem>
			   <MDBNavLink className="waves-effect waves-light" to="#!"><div  style={{ position: "centre", padding: "10px 10px"}} >{this.state.user_name}</div>
			   </MDBNavLink>
			 </MDBNavItem>
			 <MDBNavItem>
              <MDBDropdown>
                <MDBDropdownToggle nav caret>
                  {/* <MDBIcon icon="user" /> */}
				  <img src={this.state.img_url} className="rounded-circle z-depth-0"
                    style={{ height: "40px", padding: 0 }} alt="" />
				  {/* <div id="user_img"><img src={this.state.img_url}/></div> */}
                </MDBDropdownToggle>
                <MDBDropdownMenu className="dropdown-default">
                  {/* <MDBDropdownItem href="#!">Action</MDBDropdownItem>
                  <MDBDropdownItem href="#!">Another Action</MDBDropdownItem>
                  <MDBDropdownItem href="#!">Something else here</MDBDropdownItem> */}
                  {/* <MDBDropdownItem > */}
				  <GoogleLogout
                   clientId='374169744841-t3ekshrangb1aerf3th3kuv8fsu5efbq.apps.googleusercontent.com'
				   buttonText="Logout"
                    onLogoutSuccess={this.signOut}>
                  </GoogleLogout>
				  {/* </MDBDropdownItem> */}
                </MDBDropdownMenu>
              </MDBDropdown>
            </MDBNavItem>
			 </>
			 :
            <MDBNavItem>
              <MDBNavLink className="waves-effect waves-light" to={this.state.user_id}>
			  <GoogleLogin
                   clientId='374169744841-t3ekshrangb1aerf3th3kuv8fsu5efbq.apps.googleusercontent.com'
                   onSuccess={this.onSignIn}
                   isSignedIn={true}/>
              </MDBNavLink>
            </MDBNavItem>
			}
          </MDBNavbarNav>
        </MDBCollapse>
      </MDBNavbar>
    </Router>
    );
  }
}

export default NavBar;